import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import '../../css/header.css';
import TypeWriter from "../typeWriter";
import {useLocalization} from "../../context/localization";

const HeaderImage = ({ data }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const { language } = useLocalization();

    useEffect(() => {
        if (!data || !data?.image || !data.image?.data?.length) return;

        const intervalId = setInterval(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % data.image.data?.length);
        }, 6000);

        return () => clearInterval(intervalId);
    }, [data]);

    const currentImageUrl = data?.image?.data[currentImageIndex]?.attributes?.url;

    console.log("language",language)
    if (!currentImageUrl) {
        return <div>Images are not available at the moment.</div>;
    }

    return (
        <div className="header-image-container">
            <div className="transparan-text">{data?.transparanText}</div>
            <div className="text-animation">
                <TypeWriter text={data?.textAnimation?.toLocaleUpperCase(language === 'tr' ? 'tr-TR' : 'en-US')}/>
            </div>

            <div>
                <LazyLoad once offset={100}>
                    <img src={currentImageUrl} className={"img-fixed-height"} alt="Header"/>
                </LazyLoad>

            </div>

        </div>
    );
};

export default HeaderImage;
